import { render, staticRenderFns } from "./DvMenu.vue?vue&type=template&id=02df4ce7&lang=pug"
import script from "./DvMenu.vue?vue&type=script&lang=js"
export * from "./DvMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports